import React, { useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { bindActionCreators } from "redux";
import { doGet, doPost, doPut } from "../../../../utils/request";
import {
  Button,
  Tabs,
  Form,
  Input,
  Alert,
  Typography,
  Row,
  Col,
  Select,
  Radio,
  Image,
  Spin,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  CompassOutlined,
  ConsoleSqlOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as propertyActions from "../../../../actionCreators/Property";
import { useHistory, useParams } from "react-router-dom";
import MapContainer from "../../../../Components/MapContainer";
import { fallBackImage } from "../../../../utils/fallbackImage";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import PopupModal from "../../../../Components/PopupModal";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import BasicDetails from "./BasicDetails";
import LocationDetails from "./LocationDetails";
import "./style/viewProperty.css";
import Atv from "./Atv";
import Occupier from "./Occupier";
import CRF from "./crf";
import * as changeRequestActions from "../../../../actionCreators/ChangeRequest";
import { useEffect } from "react";
import AtvV2 from "./AtvV2";
import { addEllipsis } from "../../../../utils";

const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const ViewProperty = ({
  setPropertyApproval,
  getCurrentProperty,
  resetCurrentProperty,
  closeViewProperty,
  propertyTypes,
  // buildingTypes,
  // getBuildingTypes,
  getPropertyTypes,
  // getLocalities,
  currentProperty,
}) => {
  const history = useHistory();
  let disabled = true;
  const { id } = useParams();
  const [rowData, setData] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showCRFRejectModal, setCRFShowRejectModal] = useState(false);
  const [rejectionNote, setRejectionNote] = useState("");
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showCRFApproveModal, setCRFShowApproveModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRejectionTab, setShowRejectionTab] = useState(false);
  const [propertyImages, setPropertyImages] = useState(
    rowData?.data?.documents
  );

  const [buildingType, setBuildingType] = React.useState(
    rowData?.building_type
  );
  const [objectionSubmitted, setObjecitonSubmitted] = useState(false);
  const [objectionSent, setObjecitonSent] = useState(false);
  const [objectionId, setObjectionID] = useState(null);
  React.useEffect(() => {
    setData(null);
    setShowRejectModal(false);
    setCRFShowRejectModal(false);
    setRejectionNote("");
    setShowApproveModal(false);
    setCRFShowApproveModal(false);
    setShowWarning(false);
    setLoading(false);
    setShowRejectionTab(false);
    setObjecitonSubmitted(false);
    setObjecitonSent(false);
    setObjectionID(null);
    getCurrentProperty({ id: id });
  }, [id]);

  React.useEffect(() => {
    setData(currentProperty.data);
  }, [currentProperty]);
  React.useEffect(() => {
    if (rowData) {
      if (rowData?.data?.approval_status === "rejected") {
        setShowRejectionTab(true);
      } else {
        setShowRejectionTab(false);
      }
      if (rowData?.data?.documents) {
        setPropertyImages(rowData?.data?.documents);
      }
      if (rowData?.data?.property_owners) {
        for (let i = 0; i < rowData?.data?.property_owners?.length; i++) {
          if (
            rowData?.data?.property_owners[i]?.objections !== [] &&
            rowData?.data?.property_owners[i]?.objections[0]?.status ===
              "submitted"
          ) {
            setObjecitonSubmitted(true);
            setObjecitonSent(false);
            setObjectionID(
              rowData?.data?.property_owners[i]?.objections[0]?.id
            );
          } else if (
            rowData?.data?.property_owners[i]?.objections !== [] &&
            rowData?.data?.property_owners[i]?.objections[0]?.status === "sent"
          ) {
            setObjecitonSent(true);
            setObjecitonSubmitted(false);
          }
        }
      }
    }
  }, [rowData]);
  React.useEffect(() => {
    getPropertyTypes();
    // getBuildingTypes();
    // getLocalities({ circle_id: rowData?.circle_id });
  }, []);
  const handleSubmitForm = async (values, actions) => {};
  const closeViewPropertyForm = () => {
    if (history.goBack.length === 0) {
      history.push("/properties/" + rowData?.data?.status);
    } else {
      history.goBack();
    }
  };
  function callback(key) {}
  const handleBuildingTypeChange = (data) => {
    setBuildingType(data);
  };
  const handleApproveRejectButtons = async (status) => {
    setLoading(true);
    let approvalObject = {
      id: rowData.data.id,
      approval_status: status,
      pin:
        rowData?.data?.district?.code +
        rowData?.data?.circle?.code +
        rowData?.data?.id,
    };

    if (status === "rejected") {
      approvalObject = {
        ...approvalObject,
        rejected_note: rejectionNote?.trim(),
      };
    }
    const approval_reject = await doPost(
      `/properties/approval`,
      approvalObject
    );
    setLoading(false);

    if (history.goBack.length === 0) {
      history.push("/properties/" + rowData.data.status);
    } else {
      history.goBack();
    }
  };
  const handleApproveButtonClick = () => {
    setShowApproveModal(true);
  };
  const handleRejectButtonClick = () => {
    setShowRejectModal(true);
  };
  const onClickButtonPh9Form = (data) => {
    getCurrentProperty(data);
    history.push("/properties/ph9/" + id);
  };
  const onClickButtonPH1Form = (data) => {
    // taxCollectionActions.resetTaxCollection()
    // setRowData(data);
    getCurrentProperty(data);
    history.push("/properties/ph1/" + id);
  };
  const handleRejectionNote = (e) => {
    setRejectionNote(e.target.value);
  };
  const handleCRFApproveButtonClick = () => {
    setCRFShowApproveModal(true);
  };
  const handleCRFRejectButtonClick = () => {
    setCRFShowRejectModal(true);
  };
  const handleCRFRejectionNote = (e) => {
    setRejectionNote(e.target.value);
  };
  const handleCRFApproveRejectButtons = async (status) => {
    setLoading(true);
    let approvalObject = {
      id: rowData?.data.change_requests[0].id,
    };
    if (status === "rejected") {
      approvalObject = {
        ...approvalObject,
        status: "REJECTED",
        property_id: rowData?.data?.id,
        rejection_note: rejectionNote,
      };
    } else {
      if (status === "approved") {
        approvalObject = {
          ...approvalObject,
          property_id: rowData?.data?.id,
          status: "APPROVED",
        };
      }
    }
    const updatChangeRequest = await doPut(`/changerequest`, approvalObject);
    setCRFShowApproveModal(false);
    setCRFShowRejectModal(false);
    setLoading(false);
    history.goBack();
  };
  const handleForwardObjection = async () => {
    resetCurrentProperty();
    let data = {
      objection_id: objectionId,
      property_id: id,
    };
    const response = await doPost("/properties/forward-to-ti", data);
    if (response?.data?.success === true) {
      history.goBack();
    }
  };

  return (
    <React.Fragment>
      {!rowData ? (
        <div
          style={{
            width: "100%",
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <div className="header">
            <Typography className="heading">
              <span className="heading-faded">Properties</span> /{" "}
              {rowData?.data?.property_owners?.length > 0
                ? addEllipsis(rowData?.data?.property_owners[0]?.name)
                : "--"}
            </Typography>
            {rowData?.data?.submission_type === "submitted" &&
            rowData?.data?.approval_status !== "approved" ? (
              <div className="approval-button-section">
                <Button
                  className="reject-property-button"
                  type="ghost"
                  onClick={() => handleRejectButtonClick()}
                  icon={<CloseOutlined />}
                >
                  REJECT
                </Button>
                <Button
                  className="approve-property-button"
                  type="default"
                  onClick={() => handleApproveButtonClick()}
                  icon={<CheckOutlined />}
                >
                  APPROVE
                </Button>
              </div>
            ) : rowData?.data?.change_requests?.length > 0 &&
              rowData?.data?.change_requests[0]?.status == "submitted" &&
              rowData?.data?.change_requests[0]?.approval_status ==
                "APPROVED" &&
              objectionSubmitted === false &&
              objectionSent === false ? (
              <div className="approval-button-section">
                <Button
                  className="PH9-button"
                  type="ghost"
                  onClick={() => onClickButtonPh9Form(rowData?.data)}
                >
                  OPEN PH9
                </Button>
                <Button
                  className="approval-ph1-button"
                  type="default"
                  onClick={() => onClickButtonPH1Form(rowData?.data)}
                  icon={<FilePdfOutlined />}
                >
                  OPEN CURRENT PH1
                </Button>
              </div>
            ) : rowData?.data?.change_requests?.length > 0 &&
              rowData?.data?.change_requests[0]?.status == "submitted" &&
              rowData?.data?.change_requests[0]?.approval_status ==
                "REJECTED" ? (
              <div className="approval-button-section">
                <Button
                  className="approval-ph1-button"
                  type="default"
                  onClick={() => onClickButtonPH1Form(rowData?.data)}
                  // icon={<CheckOutlined />}
                >
                  OPEN CURRENT PH1
                </Button>
              </div>
            ) : objectionSubmitted ? (
              <div className="approval-button-section">
                <Button
                  className="PH9-button"
                  style={{ width: "200px" }}
                  type="ghost"
                  onClick={handleForwardObjection}
                >
                  FORWARD TO INSPECTOR
                </Button>
                <Button
                  className="approval-ph1-button"
                  type="default"
                  onClick={() => onClickButtonPH1Form(rowData?.data)}
                  icon={<FilePdfOutlined />}
                >
                  OPEN CURRENT PH1
                </Button>
              </div>
            ) : rowData?.data?.change_requests?.length > 0 &&
              rowData?.data?.change_requests[0]?.status == "submitted" &&
              rowData?.data?.change_requests[0]?.approval_status == null ? (
              <div className="approval-button-section">
                <Button
                  className="reject-property-button"
                  type="ghost"
                  onClick={() => handleCRFRejectButtonClick()}
                  // icon={<CloseOutlined />}
                >
                  DECLINE
                </Button>
                <Button
                  style={{ width: "200px" }}
                  className="approve-property-button"
                  type="default"
                  onClick={() => handleCRFApproveButtonClick()}
                  // icon={<CheckOutlined />}
                >
                  APPROVE & ISSUE PH9
                </Button>
              </div>
            ) : rowData?.data?.status === "registered" ? (
              <div className="approval-button-section">
                <Button
                  className="approval-ph1-button"
                  type="default"
                  onClick={() => onClickButtonPH1Form(rowData?.data)}
                  // icon={<CheckOutlined />}
                >
                  OPEN CURRENT PH1
                </Button>
              </div>
            ) : rowData?.data?.approval_status === "rejected" ? (
              <Typography className="rejected-status-typography">
                Rejected
              </Typography>
            ) : null}
          </div>
          <div style={{ display: "flex ", justifyContent: "space-between" }}>
            <Formik
              initialValues={{
                with_effect_date: rowData?.data?.with_effect_date
                  ? moment(rowData?.data?.with_effect_date).format(
                      "DD MMMM YYYY"
                    )
                  : null,
                district: rowData?.data?.district?.name,
                rating_area: rowData?.data?.rating_area,
                locality: rowData?.data?.locality,
                ward: rowData?.data?.ward,
                cnic:
                  rowData?.data?.property_owners?.length > 0
                    ? rowData?.data?.property_owners[0]?.cnic
                    : "",
                tehsil: rowData?.data?.tehsil?.name,
                circle: rowData?.data?.circle?.name,
                locality_code: rowData?.data?.locality_code,
                block_name: rowData?.data?.block_name,
                pin: rowData?.data?.pin,
                serial_number: rowData?.data?.serial_number,
                existing_code: rowData?.data?.existing_code,
                street_address: rowData?.data?.street_address,
                latitude: rowData?.data?.latitude,
                longitude: rowData?.data?.longitude,
                property_type: rowData?.data?.property_type?.name,
                property_id: rowData?.data?.property_id,
                total_land_area: rowData?.data?.total_land_area,
                total_covered_area: rowData?.data?.total_covered_area,
                number_of_stories: rowData?.data?.number_of_stories,
                number_of_rooms: rowData?.data?.number_of_rooms,
                accommodation: rowData?.data?.accommodation,
                residential_old: rowData?.data?.residential_old,
                commercial_old: rowData?.data?.commercial_old,
                residential_new: rowData?.data?.residential_new,
                commercial_new: rowData?.data?.commercial_new,
                payable_rent: rowData?.data?.payable_rent,
                location: rowData?.data?.location,
                construction_year: rowData?.data?.construction_year
                  ? moment(rowData?.data?.construction_year).format(
                      "DD MMMM YYYY"
                    )
                  : null,
                reconstruction_year: rowData?.data?.reconstruction_year
                  ? moment(rowData?.data?.reconstruction_year).format(
                      "DD MMMM YYYY"
                    )
                  : null,
                garv_assessed: rowData?.data?.garv_assessed,
                rejected_note: "\n" + rowData?.data?.rejected_note,
                annual_rental_value:
                  rowData?.data?.property_reduction?.annual_rental_value,
                annual_value_fixed_appeal:
                  rowData?.data?.property_reduction?.annual_value_fixed_appeal,
                annual_value_fixed_objection:
                  rowData?.data?.property_reduction
                    ?.annual_value_fixed_objection,
                total_reduction:
                  rowData?.data?.property_reduction?.total_reduction,
                remarks: rowData?.data?.property_reduction?.remarks,
                property_owners: rowData?.data?.property_owners,
                occupiers: rowData?.data?.occupiers,
                inspector: rowData?.data?.property_inspector?.user?.full_name,
                eto_name: rowData?.data?.user?.full_name,
                highway_name: rowData?.data?.highway?.name,
                highway_from: rowData?.data?.highway_from,
                highway_to: rowData?.data?.highway_to,
                highway_kms: rowData?.data?.highway_kms,
                property_number: rowData?.data?.id,
                khasra_no: rowData?.data?.khasra_number,
                mouza: rowData?.data?.mouza?.name,
                classification: rowData?.data?.classification?.name,
                annual_taxable_value:
                  "RS. " +
                  rowData?.data?.taxes[
                    rowData?.data?.taxes?.length - 1
                  ]?.annual_taxable_value.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                annual_tax:
                  "RS. " +
                  rowData?.data?.taxes[
                    rowData?.data?.taxes?.length - 1
                  ]?.annual_tax.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                type_of_structure: rowData?.data?.atv?.type_of_structure?.name,
                effects_from: rowData?.data?.atv?.effects_from?.name,
                land_area_unit: rowData?.data?.atv?.land_area_unit?.name,
                land_area: rowData?.data?.atv?.land_area,
                number_of_stories: rowData?.data?.atv?.number_of_stories,
                number_of_rooms: rowData?.data?.atv?.number_of_rooms,
                structure_rate:
                  "RS. " +
                  rowData?.data?.atv?.structure_rate
                    ?.toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                dc_rate:
                  "RS. " +
                  rowData?.data?.atv?.dc_rate
                    ?.toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                covered_area: rowData?.data?.atv?.covered_area,
                locality: rowData?.data?.locality,
                address:
                  rowData?.data?.plot_number +
                  "," +
                  rowData?.data?.street_address +
                  "," +
                  rowData?.data?.road_name,
              }}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={(values, actions) => handleSubmitForm(values, actions)}
            >
              {(formikProps) => {
                const { errors, isSubmitting, handleSubmit } = formikProps;

                return (
                  <>
                    {Object.keys(errors).length > 0 && (
                      <Alert
                        message={errors.email || errors.password || errors.auth}
                        type="error"
                        showIcon
                        className="column-error"
                      />
                    )}
                    <Form
                      onFinish={handleSubmit}
                      className={
                        rowData?.data?.change_requests?.length > 0
                          ? "fwidth"
                          : "widh"
                      }
                    >
                      <Tabs
                        defaultActiveKey={
                          rowData?.data?.change_requests?.length > 0
                            ? "crf"
                            : "existing"
                        }
                        onChange={callback}
                        className="tab-main"
                      >
                        <TabPane
                          tab="BASIC DETAILS"
                          key="basic"
                          className="tab-pane"
                        >
                          <BasicDetails
                            disabled={disabled}
                            highwayFrom={rowData.data.highway_from}
                            highwayTo={rowData.data.highway_to}
                            unregisteredProperty={
                              (rowData?.data?.submission_type === "submitted" &&
                                rowData?.data?.approval_status !==
                                  "approved") ||
                              rowData?.data?.approval_status === "rejected"
                            }
                            rowData={rowData.data}
                          />
                        </TabPane>
                        <TabPane
                          tab="LOCATION DETAILS"
                          key="location"
                          className="tab-pane"
                        >
                          <LocationDetails
                            propertyType
                            handlePropertyTypeChange
                            propertyTypes={propertyTypes}
                            Option
                            MapContainer
                            rowData={rowData?.data}
                            disabled={disabled}
                          />
                        </TabPane>
                        <TabPane
                          tab="OWNERSHIP"
                          key="ownership"
                          className="tab-pane"
                        >
                          <Tabs tabPosition="left" className="tab-side">
                            {rowData?.data?.property_owners?.map(
                              (owner, index) => {
                                return (
                                  <TabPane
                                    tab={<p>{owner.name}</p>}
                                    key={index}
                                  >
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="Name"
                                          name={`property_owners[${index}].name`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="CNIC"
                                          name={`property_owners[${index}].cnic`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            rowData?.data?.property_owners[
                                              index
                                            ].cnic === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="Father/Husband Name"
                                          name={`property_owners[${index}].father_name`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            rowData?.data?.property_owners[
                                              index
                                            ].father_name === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].email`}
                                          labelText="Email"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            rowData?.data?.property_owners[
                                              index
                                            ].email === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].phone_number`}
                                          labelText="Cell No"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            rowData?.data?.property_owners[
                                              index
                                            ].phone_number === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].shares`}
                                          labelText="Share %"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            (rowData?.data?.property_owners[
                                              index
                                            ].shares === "" ||
                                              rowData?.data?.property_owners[
                                                index
                                              ].shares === null ||
                                              rowData?.data?.property_owners[
                                                index
                                              ].shares === undefined ||
                                              rowData?.data?.property_owners[
                                                index
                                              ].shares === 0) &&
                                            "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <b>Document Proof</b>
                                      </Col>
                                    </Row>
                                    {owner.documents &&
                                      owner.documents.map((image) => {
                                        return (
                                          <div className="image-parser">
                                            <Image
                                              width={200}
                                              height={200}
                                              className="image"
                                              src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                              // fallback={fallBackImage}
                                            />
                                            <span
                                              style={{
                                                position: "absolute",
                                                bottom: 0,
                                                width: "100%",
                                                backgroundColor: "#34343438",
                                                fontWeight: 600,
                                                color: "white",
                                                textAlign: "center",
                                              }}
                                            >
                                              {moment(image.created_at).format(
                                                "DD-MM-YYYY  hh:mm"
                                              )}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    <Row>
                                      {(!owner.documents ||
                                        owner.documents.length == 0) && (
                                        <span>No proof attached</span>
                                      )}
                                    </Row>
                                  </TabPane>
                                );
                              }
                            )}
                          </Tabs>
                        </TabPane>
                        <TabPane
                          tab="OCCUPIER"
                          key="occupier"
                          className="tab-pane"
                        >
                          <Occupier
                            rowData={rowData?.data}
                            buildingType={buildingType}
                            // buildingTypes={buildingTypes}
                            handleBuildingTypeChange={handleBuildingTypeChange}
                            disabled={disabled}
                          />
                        </TabPane>

                        <TabPane tab="ATV" key="atv" className="tab-pane">
                          <AtvV2
                            disabled={disabled}
                            atvData={rowData?.data?.atv}
                          />
                        </TabPane>
                        <TabPane tab="IMAGES" key="images" className="tab-pane">
                          {propertyImages &&
                            propertyImages.map((image) => {
                              return (
                                <div className="image-parser">
                                  <Image
                                    width={200}
                                    height={200}
                                    className="image"
                                    src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                    fallback={fallBackImage}
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      bottom: 0,
                                      width: "100%",
                                      backgroundColor: "#34343438",
                                      fontWeight: 600,
                                      color: "white",
                                      textAlign: "center",
                                    }}
                                  >
                                    {moment(image.created_at).format(
                                      "DD-MM-YYYY  hh:mm"
                                    )}
                                  </span>
                                </div>
                              );
                            })}
                          {(!propertyImages || propertyImages?.length == 0) && (
                            <span>No property images were added</span>
                          )}
                        </TabPane>
                        {/* {rowData?.data?.change_requests?.length > 0 && (
                          <TabPane
                            tab="CHANGE REQUEST"
                            key="crf"
                            className="tab-pane"
                          >
                            <ChangeRequest
                              disabled={disabled}
                              data={rowData?.data?.change_requests}
                            />
                          </TabPane>
                        )} */}
                        {showRejectionTab ? (
                          <TabPane tab="NOTE" key="note" className="tab-pane">
                            <Field
                              InputType={TextArea}
                              component={FormInputField}
                              name="rejected_note"
                              labelText="Reason for Rejection"
                              hideErrorMessage={true}
                              className="text-field"
                              disabled={true}
                              rows={6}
                            />
                          </TabPane>
                        ) : null}
                      </Tabs>
                      <div className="close-property-section">
                        <Button
                          className="close-property-button"
                          type="primary"
                          onClick={closeViewPropertyForm}
                        >
                          Close
                        </Button>
                      </div>
                    </Form>
                  </>
                );
              }}
            </Formik>

            {rowData?.data?.change_requests?.length > 0 && (
              <div style={{ width: "27%", overflow: "hidden" }}>
                <CRF data={rowData?.data} />
              </div>
            )}
          </div>
          <PopupModal
            title={"Approve Property"}
            centered
            visible={showApproveModal}
            onOk={() => handleApproveRejectButtons("approved")}
            onCancel={() => setShowApproveModal(false)}
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => setShowApproveModal(false)}
              >
                CANCEL
              </Button>,
              <Button
                key="submit"
                type="link"
                loading={loading}
                onClick={() => {
                  handleApproveRejectButtons("approved");
                }}
              >
                APPROVE
              </Button>,
            ]}
          >
            <p>Are you sure you want to approve this Property?</p>
          </PopupModal>
          <PopupModal
            title={"Rejection reason"}
            centered
            visible={showRejectModal}
            onCancel={() => setShowRejectModal(false)}
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => setShowRejectModal(false)}
              >
                CANCEL
              </Button>,
              <Button
                key="submit"
                type="link"
                loading={loading}
                onClick={() => {
                  if (rejectionNote?.trim() === "") {
                    setShowWarning(true);
                  } else {
                    handleApproveRejectButtons("rejected");
                  }
                }}
              >
                REJECT
              </Button>,
            ]}
          >
            <TextArea
              rows={4}
              name="rejection-note"
              placeholder="Note"
              onChange={handleRejectionNote}
              value={rejectionNote}
            />
          </PopupModal>
          <PopupModal
            title={"Warning"}
            centered
            visible={showWarning}
            onCancel={() => setShowWarning(false)}
            footer={[
              <Button
                key="submit"
                type="link"
                onClick={() => {
                  setShowWarning(false);
                }}
              >
                OK
              </Button>,
            ]}
          >
            Enter a valid rejection reason.
          </PopupModal>
          <PopupModal
            title={"Approve CRF"}
            centered
            visible={showCRFApproveModal}
            onOk={() => handleCRFApproveRejectButtons("approved")}
            onCancel={() => setCRFShowApproveModal(false)}
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => setCRFShowApproveModal(false)}
              >
                CANCEL
              </Button>,
              <Button
                key="submit"
                type="link"
                loading={loading}
                onClick={() => {
                  handleCRFApproveRejectButtons("approved");
                }}
              >
                APPROVE
              </Button>,
            ]}
          >
            <p>Are you sure you want to approve this change request?</p>
          </PopupModal>
          <PopupModal
            title={"Rejection reason"}
            centered
            visible={showCRFRejectModal}
            onCancel={() => setCRFShowRejectModal(false)}
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => setCRFShowRejectModal(false)}
              >
                CANCEL
              </Button>,
              <Button
                key="submit"
                type="link"
                loading={loading}
                onClick={() => {
                  if (rejectionNote === "") {
                    setShowWarning(true);
                  } else {
                    handleCRFApproveRejectButtons("rejected");
                  }
                }}
              >
                REJECT
              </Button>,
            ]}
          >
            <TextArea
              rows={4}
              name="rejection-note"
              placeholder="Note"
              onChange={handleCRFRejectionNote}
              value={rejectionNote}
            />
          </PopupModal>
          <PopupModal
            title={"Warning"}
            centered
            visible={showWarning}
            onCancel={() => setShowWarning(false)}
            footer={[
              <Button
                key="submit"
                type="link"
                onClick={() => {
                  setShowWarning(false);
                }}
              >
                OK
              </Button>,
            ]}
          >
            Enter a valid rejection reason.
          </PopupModal>
        </>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({
  property: { currentProperty },
  dropDown: {
    propertyTypes /*, buildingTypes*/,
    localities,
    localityCodes,
    blocks,
  },
}) => ({
  propertyTypes,
  // buildingTypes,
  localities,
  localityCodes,
  blocks,
  currentProperty,
});

const mapDispatchToProps = (dispatch) => ({
  // getBuildingTypes: bindActionCreators(
  //   dropDownActions.getBuildingTypes,
  //   dispatch
  // ),
  getPropertyTypes: bindActionCreators(
    dropDownActions.getPropertyTypes,
    dispatch
  ),
  // getLocalities: bindActionCreators(dropDownActions.getLocalities, dispatch),
  // getLocalityCodes: bindActionCreators(
  //   dropDownActions.getLocalityCodes,
  //   dispatch
  // ),
  getBlocks: bindActionCreators(dropDownActions.getBlocks, dispatch),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
  resetCurrentProperty: bindActionCreators(
    propertyActions.resetCurrentProperty,
    dispatch
  ),
  setPropertyApproval: bindActionCreators(
    propertyActions.setPropertyApproval,
    dispatch
  ),
  updateChangeRequest: bindActionCreators(
    changeRequestActions.updateChangeRequest,
    dispatch
  ),
});

ViewProperty.propTypes = {
  getPropertyTypes: PropTypes.func.isRequired,
  // getBuildingTypes: PropTypes.func.isRequired,
  propertyTypes: PropTypes.array.isRequired,
  // buildingTypes: PropTypes.array.isRequired,
  setPropertyApproval: PropTypes.func.isRequired,
  closeViewProperty: PropTypes.func.isRequired,
  // getLocalities: PropTypes.func.isRequired,
  // getLocalityCodes: PropTypes.func.isRequired,
  getWards: PropTypes.func.isRequired,
  getBlocks: PropTypes.func.isRequired,
  localities: PropTypes.object.isRequired,
  localityCodes: PropTypes.object.isRequired,
  wards: PropTypes.object.isRequired,
  blocks: PropTypes.object.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
  resetCurrentProperty: PropTypes.func.isRequired,
  currentProperty: PropTypes.object.isRequired,
  updateChangeRequest: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProperty);
